import ScalarIconSwap_vue_vue_type_script_setup_true_lang_default from "./ScalarIconSwap.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconSwap.vue
var ScalarIconSwap_default = ScalarIconSwap_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconSwap_default as default };

//# sourceMappingURL=ScalarIconSwap.js.map